import React from 'react';
import { Tooltip, Box } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { PartialAudienceFragment } from '@occc/graphql';
import { Typography, LinkChip } from '@occc/ui-design-system';

import { AudienceDetails } from './AudienceDetails';

import { routeCreator } from '../../../../../routes/Audience/utils';
interface IInAudienceProps {
  audiences?: PartialAudienceFragment[];
  loading: boolean;
  error?: ApolloError;
}

export const InAudience: React.FC<IInAudienceProps> = ({ audiences, loading, error }) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }

  if (loading && !audiences) {
    return <Typography>Loading...</Typography>;
  }

  if (!audiences) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }
  return (
    <Box mb={1}>
      <Typography variant='body2' gutterBottom>
        Audiences
      </Typography>
      {audiences.map((audience) => (
        <Tooltip
          key={audience.uuid}
          title={<AudienceDetails audience={audience} />}
          sx={{
            bgcolor: 'transparent',
            p: 0,
            maxWidth: 480,
          }}
        >
          <Box mr={1} mb={1} component='span'>
            <LinkChip label={audience.name} href={routeCreator.details(audience.uuid)} />
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};
